export default "__VITE_ASSET__CuoAvqT6__"